import { Box, Input } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { pxToRem } from '../../theme';
import { Field, InputGroup } from '../snippets';

export function AddressInput({
  label,
  errorMessage,
  value,
  setValue,
  isValidAddress,
  placeholder,
  onClickRightElement,
  labelRighElement,
}: {
  label?: ReactNode;
  errorMessage?: string;
  value: string;
  setValue: (address: string) => void;
  isValidAddress: boolean;
  placeholder?: string;
  onClickRightElement?: () => void;
  labelRighElement?: string;
}) {
  return (
    <Field
      label={label}
      invalid={value === '' ? undefined : !isValidAddress}
      errorText={errorMessage || 'Provided Ethereum address is invalid'}
    >
      <InputGroup
        endElement={
          onClickRightElement ? (
            <Box
              cursor="pointer"
              color="primary"
              fontSize="xs"
              fontWeight="medium"
              textAlign="center"
              width={pxToRem(82)}
              onClick={onClickRightElement}
            >
              {labelRighElement || 'Use connected address'}
            </Box>
          ) : null
        }
      >
        <Input
          placeholder={placeholder || '0xabc123...'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </InputGroup>
    </Field>
  );
}
